import { LanderBreakdownEntry } from '../api/models';
import { DashboardCard } from './ui';

interface Props {
    title: string;
    entries: LanderBreakdownEntry[];
    loading?: boolean;
    limit?: number;
}

export function LanderBreakdownCard({ title, entries, loading, limit = 8 }: Props) {
    const top = entries.slice(0, limit);
    const max = top.length > 0 ? Math.max(...top.map((e) => e.visitors)) : 0;

    return (
        <DashboardCard title={
            <div className="flex items-center w-full">
                <h3 className="text-base font-semibold text-text m-0">{title}</h3>
                {entries.length > limit && (
                    <span className="ml-auto text-text-3 font-mono text-[10px]">top {limit} of {entries.length}</span>
                )}
            </div>
        }>
            {loading ? (
                <span className="text-text-3 text-sm">Loading...</span>
            ) : top.length === 0 ? (
                <span className="text-text-3 text-sm">No data in this period.</span>
            ) : (
                <div className="flex flex-col gap-0.5">
                    {top.map((e) => (
                        <div
                            key={e.value}
                            title={`${e.value} — ${e.visitors.toLocaleString()} uniques, ${e.pageviews.toLocaleString()} pageviews`}
                            className="relative flex items-center gap-2 px-1.5 py-1 rounded overflow-hidden"
                        >
                            <span
                                aria-hidden
                                className="absolute inset-y-0 left-0 bg-accent/10 rounded"
                                style={{ width: max > 0 ? `${(e.visitors / max) * 100}%` : 0 }}
                            />
                            <span className="relative flex-1 min-w-0 truncate text-text-2 text-sm">{e.value || '(none)'}</span>
                            <span className="relative text-text font-mono text-sm tabular-nums">{e.visitors.toLocaleString()}</span>
                            <span className="relative w-[54px] text-right text-text-3 font-mono text-2xs tabular-nums">
                                {e.pageviews.toLocaleString()}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
}

export default LanderBreakdownCard;
